<template>
  <NuxtErrorBoundary @error="(e: any) => handleUncaughtError(e)">
    <VueQueryDevtools />
    <div>
      <span
        v-if="envWatermark"
        class="absolute bottom-1 left-1 uppercase text-[8px] font-semibold text-black opacity-30 z-[1000000]"
        >{{ envWatermark }}</span
      >
      <NuxtLoadingIndicator
        color="repeating-linear-gradient(to right,#4f46e5 20%,#4f46e5 100%)"
        :height="2"
      />
      <NuxtLayout>
        <NuxtPage />
      </NuxtLayout>
      <!-- TOAST -->
      <AppToastNotificationDefault />
      <AppToastNotificationError />
      <AppToastNotificationInteractionEnd />
      <AppToastNotificationOffline />
      <AppToastNotificationFileSubmissionUpload />
      <AppToastNotificationFileSubmissionProcessing />
      <AppToastNotificationSpinner />
      <AppToastNotificationAppUpdate />
      <!-- DIALOG -->
      <DialogHandler />
    </div>
  </NuxtErrorBoundary>
</template>

<script setup lang="ts">
import * as Sentry from '@sentry/vue'
import { VueQueryDevtools } from '@tanstack/vue-query-devtools'
import { SseMessageType } from '~/types/SseMessage'

function handleUncaughtError(e: any) {
  Sentry.captureException(e)
  console.error(e)
  showError({
    statusCode: e.statusCode || 500,
    statusMessage:
      e.statusMessage || e.message || 'An unexpected error occurred',
    message: e.message || e.statusMessage || 'An unexpected error occurred',
  })
}

const { addToast, removeToastsByType } = useToastNotifications()
const isOnline = useOnlineStatus()

watch(isOnline, (online) => {
  if (online) {
    removeToastsByType('offline')
  } else {
    addToast({
      type: 'offline',
      heading: 'You are offline',
      message: '',
    })
  }
})

const config = useRuntimeConfig()
const envWatermark = computed(() => {
  if (config.public.environment === 'production') return null

  return config.public.environment
})

// App Updates ===============================================================
function displayAppRefreshMessage() {
  addToast({
    type: 'app-update',
  })
}

onEvent(SseMessageType.APP_UPDATE_REFRESH, displayAppRefreshMessage)
</script>
